module.exports = __webpack_public_path__ + "img/sectiondownarrow.c57434ef.svg";